var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{clip-path:url(#clip-path-2);}.cls-4{fill:url(#linear-gradient);}.cls-5{fill:#fff;fill-rule:evenodd;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.5,20A19.5,19.5,0,1,1,20,.5,19.5,19.5,0,0,1,39.5,20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -278,
    y1: 440.51,
    x2: -277.92,
    y2: 440.51,
    gradientTransform: "matrix(497.85, 448.27, 448.27, -497.85, -59062.43, 343929.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0496fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0496fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#0496fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#0596fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#0595fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#0894fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0a92fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0d91fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0f8ffc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#118efc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#148cfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#168bfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#188afc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#1b88fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#1d87fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#1f85fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#2284fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#2482fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#2681fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2980fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2b7efe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2d7dfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#307bfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#327afe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3578fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3777fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3976ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#3c74ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#3e73ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#4071ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#4270ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#456eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#476cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#496bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#4b69ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#4e68ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#5066ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#5265ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#5463ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#5761ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#5960ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#5b5eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#5d5dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#5f5bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#625aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#6458ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#6657ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#6855ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#6b53ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#6d52ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#6f50ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#714fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#734dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#764cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#784aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#7a49fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#7c49fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#7e48fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#8147fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#8347fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#8546fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#8745fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#8944fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#8c44f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#8e43f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#9042f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#9242f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#9441f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#9640f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#993ff5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#9b3ff4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#9d3ef4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#9f3df3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#a13df2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#a43cf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#a63bf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#a83bf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#aa3af0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#ac39ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#ae39ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#b038ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#b138ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#b339ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#b439e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#b539e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#b63ae4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#b73ae2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#b83ae1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#b93bdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ba3bdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#bb3bdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#bd3bd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#be3cd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#bf3cd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c03cd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c13dd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#c23dd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#c33dce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#c43ecc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#c53ecb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#c63ec9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#c83fc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#c93fc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#ca3fc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#cb3fc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#cc40c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#cd40be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#cf40ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#d140b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#d340b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#d440af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#d640ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#d840a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#da40a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#dc40a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#dd409d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#df409a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#e14096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#e34093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e4408f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e6418c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#e84188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#ea4184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#ec4181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ed417d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ef417a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f14176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f34172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f5416f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#f6416b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#f84168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#fa4164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#fc4161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#fd415d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ff415a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ff4557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fe4855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#fe4b53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#fe4e51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fd514e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fd544c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fd584a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#fd5b47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#fc5e45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fc6143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fc6441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fb673e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#fb6b3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#fb6e3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#fa7137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#fa7435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#fa7733"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#f97a31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#f97e2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#f9812c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#f9842a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#f88727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#f88a25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#f88d23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#f79021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#f7941e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#f7981d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#f89c1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#f8a01a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#f8a418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9a817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9ac16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#fab014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#fab413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#fab811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#fbbc10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#fbc00e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#fcc40d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#fcc70c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#fccb0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#fdcf09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#fdd307"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#fdd706"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#fedb04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#fedf03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ffe302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ffe601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ffe800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#ffe800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe800"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "insta"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M18-18.89-18.89,22,22,58.89,58.89,18Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M14.83,10.69H25.17a4.23,4.23,0,0,1,4.22,4.23V25.2a4.22,4.22,0,0,1-4.22,4.22H14.83a4.22,4.22,0,0,1-4.22-4.22V14.92A4.23,4.23,0,0,1,14.83,10.69ZM20,16H20a4.09,4.09,0,0,1,0,8.17H20A4.09,4.09,0,0,1,20,16Zm0-2.11H20a6.17,6.17,0,0,1,0,12.34H20a6.17,6.17,0,0,1,0-12.34Zm6.12-1.19a1.3,1.3,0,1,1,0,2.59,1.3,1.3,0,1,1,0-2.59Zm-11.31-4H25.22a6.15,6.15,0,0,1,6.12,6.12v10.4a6.14,6.14,0,0,1-6.12,6.11H14.78a6.14,6.14,0,0,1-6.12-6.11V14.86a6.15,6.15,0,0,1,6.12-6.12"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.46a1aa51b3793f624e4732683a994c62.svg";
export { ForwardRef as ReactComponent };